import { RootState } from '@reducers';

export const selectPhotoManagerDialog = (state: RootState) => state.photoManagerDialogReducer;
